export const STATUS_UPLOAD = {
  uploading: 0,
  success: 1,
  failed: 2,
  deleted: 3,
  canceled: 4
}